import api from "./api";

export const DEFAULT_SITE = {
  whatsapp: "5567996863443",
  images: {
    heroBg: "/img/colecao-bones.jpg",
    heroFg: "/img/cabelas-camo-tall.jpg",
    catBones: "/img/colecao-prl.jpg",
    catRoupas: "/img/bermudas-premium.jpg",
    catEncomendas: "/img/lifestyle-car.jpg",
    encomendasBg: "/img/colecao-prl.jpg",
    roupasHero: "/img/bermudas-premium.jpg",
    catalogoHero: "/img/colecao-bones.jpg",
  },
  instagram: [
    "/img/lifestyle-car.jpg",
    "/img/caps-quad.jpg",
    "/img/bone-af-preto-1892.jpg",
    "/img/bone-branco-logo.jpg",
    "/img/prl-duo-wood.jpg",
    "/img/bone-cabelas-camo.jpg",
  ],
  texts: {
    heroL1: "Seu estilo",
    heroL2Prefix: "começa pelo",
    heroL2Accent: "boné.",
    heroSubtitle: "Bonés importados, roupas premium e modelos exclusivos selecionados para quem não abre mão de estilo.",
    heroProof: "+1.000 clientes atendidos • Importados e Nacionais • Pronta Entrega & Encomendas",
  },
  brands: ["Polo Ralph Lauren", "Tommy Hilfiger", "Bespro Shop", "Abercrombie & Fitch"],
};

export const mergeSite = (saved) => ({
  whatsapp: (saved?.whatsapp || "").replace(/\D/g, "") || DEFAULT_SITE.whatsapp,
  images: { ...DEFAULT_SITE.images, ...(saved?.images || {}) },
  instagram: saved?.instagram?.length ? saved.instagram : DEFAULT_SITE.instagram,
  texts: { ...DEFAULT_SITE.texts, ...(saved?.texts || {}) },
  brands: saved?.brands?.length ? saved.brands : DEFAULT_SITE.brands,
});

export const getSiteSettings = async () => (await api.get("/site")).data;
